import React, { 
    Fragment, 
    useState, 
    useEffect, 
    useRef,
    useCallback,
 } from "react";
import {
  Row,
  Col,
} from "reactstrap";
import {EmpAssetList} from "."
import { 
    getItemsList,
    getAllAsset,
    addAsset,
    updateAsset,
    delAsset,
    delAssetItem,
    addItem,   
  } from "../../../../redux/actions/adminSettings/adminSettings.action";
import { connect } from "react-redux";
import {
    FormAddEditAssetItemEmployee,
  } from "../../../../components/adminSettings/assets/index";

  import {
    PopUp,
    PopUpSuccess,
  } from "../../../../components/adminSettings/assets/index";
  import Notifications from "../../../../components/common/Notifications";
  import api from "../../../../apis/api";
  import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
/*const assetList =  [
    {
        itemNo: "",
        itemModel: "itemModel",
        modelNo:"modelNo",
        uniqueIdentificationNumber:"uniqueIdentificationNumber",
        purchaseDate:"purchaseDate",
        warrantyEndDate:"warrantyEndDate",
        vendor:"vendor",
        type : "Software"
    },
    {
        itemNo: "",
        itemModel: "itemModel",
        modelNo:"modelNo",
        uniqueIdentificationNumber:"uniqueIdentificationNumber",
        purchaseDate:"purchaseDate",
        warrantyEndDate:"warrantyEndDate",
        vendor:"vendor",
        type : "Hardware"
    }];*/

const TabAssets=(props)=>{
const {getAllAsset,getItemsList,addAsset,updateAsset}=props;
const { assetList,itemList} = props.assetList;
const [assetArray,setassetArray]=useState([]);
const [selectedItem, setSelectedItem] = useState("");
const [isOpenFormAssetAddItems, setIsOpenFormAssetAddItems] = useState(false);
const [selectedAssetList, setSelectedAssetList] = useState("");
const [selectedAsset, setSelectedAsset] = useState("");
const [isOpenAssetItems, setIsOpenAssetItems] = useState(true);
const [assetItemList,setAssetItemList] = useState([]);
const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);
  const [curDelId,setcurDelId] =useState(0);
  const [error, setError] = useState(null);
  const [loaded, setLoaded] = useState(false);
   const [employeeid,setemployeeid] =useState(0);
const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;
useEffect(()=>{
  setemployeeid(props.employeeId)
    getAllAsset();
    getItemsList();
},[getAllAsset,getItemsList]);

useEffect(()=>{
    setassetArray(assetList);
    setAssetItemList(itemList);
   // console.log("itemList",itemList)
},[assetList,itemList]);

const handleAddBtnClick = useCallback(()=>{
    setIsOpenFormAssetAddItems(true);
    setIsOpenAssetItems(false);
},[setIsOpenFormAssetAddItems, setIsOpenAssetItems]);
 //  on click the tile ,open the listAssetItem.
 const handleSelectedItem = useCallback(
    (val, id) => {

      let assetArr = assetList.filter((el) => el.itemId === val.itemId);
     // console.log("assetArr",assetArr)
      setSelectedAssetList(assetArr);
      // set seleted item.
      setSelectedAsset(val);
      setSelectedItem(val);
      setIsOpenFormAssetAddItems(true);
      setIsOpenAssetItems(false);
    },
    [assetList]
  );
    // toggel from add edit asset form.
    const handleCancelFromListAssetItem = React.useCallback(() => {
        setSelectedAsset("");
        setIsOpenFormAssetAddItems(false);
        setIsOpenAssetItems(true);
    }, [setIsOpenFormAssetAddItems, setIsOpenAssetItems]);

  //  handle add assets items.
  const handleAddItemsToAsset = React.useCallback(
    (assetFormData) => {
      setLoaded(true);
      addAsset(assetFormData);
      setTimeout(() => { 
        getItemsList();
        setAssetItemList(itemList);
        setLoaded(false);
    }, 4000);
      setError({ ...error, message: "Asset added successfully...", status: 200 });
      handleCancelFromListAssetItem();
    },
    [addAsset, handleCancelFromListAssetItem,getItemsList,setAssetItemList,itemList,setLoaded]
  );
  const handleDeleteAsset = useCallback(
    (itemId) => {
      setisopenpopup((prevState) => !prevState);
      setcurDelId(itemId.itemNo);
    },
    []
  );

   // handle updated asset items.
   const handleUpdateItemsToAsset = React.useCallback(
    (assetFormData) => {
      setLoaded(true);
      updateAsset(assetFormData);
      setTimeout(() => { 
        getItemsList();
        setAssetItemList(itemList);
        setLoaded(false);
    }, 4000);
      setError({ ...error, message: "Asset updated successfully...", status: 200 });
      handleCancelFromListAssetItem();
    },
    [updateAsset, handleCancelFromListAssetItem,getItemsList,setAssetItemList,setLoaded,itemList]
  );

  const hadleDelWithPopYes =React.useCallback(() =>{
    // const res= delOfficeLoation(curDelId);
       const fetchApi = async () => {
        let array=[];
      await api.asset().del(curDelId);
      await api.asset().getAll().then((res) =>array.push(res.data));
      if(array[0] !== '')
        {
          setAssetItemList(array[0]);
        }
    }
    fetchApi();
    // delAsset(curDelId);
    
    setisopenpopup((prevState) => !prevState);
    setisopenpopupSuccess((prevState) => !prevState);
    setSelectedAsset("");
    setIsOpenAssetItems(true);
    // window.location.reload();
   
    }, [delAsset,curDelId,getItemsList,setAssetItemList,setIsOpenAssetItems,setSelectedAsset]);
  
  const hadleDelWithPopNo =React.useCallback(() =>{
   setisopenpopup((prevState) => !prevState);
  
  });
    
  const hadleSuccessPop =React.useCallback(() =>{
  
    setLoaded(true);
     setError({ ...error, message: "Asset deleted successfully...", status: 200 });
     handleCancelFromListAssetItem();
     setisopenpopupSuccess((prevState) => !prevState);
     setTimeout(() => { 
      getAllAsset();
    getItemsList();
    setassetArray(assetList);
    setAssetItemList(itemList);
    setLoaded(false);
  }, 4000);
     
  },[handleCancelFromListAssetItem,getItemsList,getAllAsset,setassetArray,assetList,setAssetItemList,itemList]);
    return (
        <Fragment>
             {isOpenAssetItems ? (
            <Row>
                <Col>
                <EmpAssetList 
                assetList={assetArray}
                isOpenAssetItems={isOpenAssetItems}
                handleSelectedAsset={handleSelectedItem}
                handleAddBtnClick = {handleAddBtnClick}
                handleDeleteAsset={handleDeleteAsset}
                employeeid={employeeid}
                ></EmpAssetList>
                </Col>
            </Row>   
             ):null}   
        <Row>
        <Col>
             {/* show edit and add asset item form */}
            {isOpenFormAssetAddItems ? (
                <FormAddEditAssetItemEmployee
                selectedItem={selectedItem}
                selectedAsset={selectedAsset}
                userList= {null}
                handleAddAsset={handleAddItemsToAsset}
                handleUpdateAsset={handleUpdateItemsToAsset}
                handleCancel={handleCancelFromListAssetItem}
                assetItemList={assetItemList}
                ></FormAddEditAssetItemEmployee>
            ) : null}
      </Col>
      </Row>
      <Notifications notifications={error}></Notifications>
      {isopenpopup == true ? (<PopUp 
    
    hadleDelWithPopYes={hadleDelWithPopYes}
    hadleDelWithPopNo={hadleDelWithPopNo}
    >

</PopUp>) : null}        
{isopenpopupSuccess == true ? (<PopUpSuccess 
    hadleSuccessPop={hadleSuccessPop}
    >

</PopUpSuccess>) : null}
<DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
        </Fragment>
      );
};

const mapStateToProps = (state) => ({
    assetList: state.adminSettingReducer,
    itemList: state.itemReducer,
  });
export default connect(mapStateToProps, {
  getItemsList,
  addItem,
  getAllAsset,
  addAsset,
  updateAsset,
  delAsset,
  delAssetItem,
  })(TabAssets);